import { twoColumnsImageSchema } from '@/feature/cms/components/two-columns-image/TwoColumnsImage.schema'
import type { z } from 'zod'
import { storeLocatorButtonSchema } from './store-locator-button.schema'

export const twoColumnsImageStoreLocatorSchema = twoColumnsImageSchema.extend({
  link: storeLocatorButtonSchema.optional(),
})

export type TwoColumnsImageStoreLocatorSchemaType = z.infer<
  typeof twoColumnsImageStoreLocatorSchema
>
